export class DeleteLineItemDto {
    requestIssueId!: number;
    requestLineIds!: number[];
}